module.exports = __webpack_public_path__ + "img/system-tw.368281b3.png";